import {useAccount} from '@azure/msal-react';
import {devBypassRoles, isDevBypassEnabled} from 'src/app/constants/config/devBypassConfig';
import {Roles} from 'src/data/enums/roles';
import {User} from 'src/data/models/user/user';

export function useUserProfile(): User {
    const account = useAccount();

    if (process.env.REACT_APP_DUMMY_DATA === 'true')
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return {
            email: 'dummy@email.com',
            name: 'Dummy User',
        };

    // With auth-bypass there is no MSAL account, so grant the same roles useAllowedRoutes uses —
    // otherwise the nav menu (which reads these roles) renders empty while the routes stay open.
    if (isDevBypassEnabled) {
        return {
            email: account?.username || 'dev-bypass@local',
            name: account?.name || 'Dev Bypass',
            'msal-roles': devBypassRoles as Roles[],
        };
    }

    return {
        email: account?.username || '',
        name: account?.name || '',
        'msal-roles': (account?.idTokenClaims?.roles || []) as Roles[],
    };
}
